import { getProductsVersions, verifyLogin } from "../../utils/api-communication/RestApiCli";
import { compareVersions } from "compare-versions";

export async function shouldShowUpdateWarning(username, password) {
  let showUpdateWarning = false;
  let redirect = false;
  if (oldAccounts.includes(username)) {
    try {
      const response = await verifyLogin({ identifier: username, password });
      if (response.data) {
        const user = response.data.user;
        const resp = await getProductsVersions(user.orgId);
        const versionsList = resp.data;
        showUpdateWarning = true;

        // if there is no product, redirect to old system
        if (versionsList?.length > 0) {
          for (const i in versionsList) {
            const item = versionsList[i];
            if (
              item["version"] &&
              item["puiVersion"] &&
              compareVersions(item["version"], "2.0.0") >= 0
            ) {
              showUpdateWarning = false;
              break;
            }
          }
        } else {
          showUpdateWarning = true;
        }
      }
    } catch (error) {
      console.error("Error: ", error);
      return { showUpdateWarning: false, redirect: false, error };
    }
  } else if (username === untouchable) {
    showUpdateWarning = false;
    try {
      const response = await verifyLogin({ identifier: username, password });
      if (response.data) {
        redirect = true;
      }
    } catch (error) {
      console.error("Error: ", error);
      return { showUpdateWarning: false, redirect: false, error };
    }
  }
  return { showUpdateWarning, redirect };
}

const untouchable = "turgaycetin";

const oldAccounts = [
  "benmirkin",
  "jacksonandgill",
  "kingsbridgehospital",
  "mcgrathsopticians",
  "panoptica",
  "krishnavision",
];

export const uaeReinbursementAccounts = ["uaetrial"];
